import React from 'react';
import AboutGroupIcon from '../../assets/icons/about-group.svg';

const About = () => {
  return (
    <div className="container-fluid bg-warning" style={{ paddingTop: '5rem'}} >
      <div className="container">
        <p className="text-center text-secondary">
         Get to know more 
        </p>
        <h1 className="text-center text-info">
          <strong>About Us</strong>
        </h1>
        <div className="row mt-5 align-items-center">
          <div className="col-12 col-md-6 order-1 order-md-0">
            <img src={AboutGroupIcon} className="img-fluid" alt="Products" />
          </div>
          <div className="col-12 col-md-6 mb-5">
            <div className="bg-white rounded-1 p-5">
              <p className="text-secondary">
                <strong>Innovation Associates Nigeria Limited</strong> was established in 2011 purposely for the distribution of caps, preforms and bottles to meet the needs of beverages industries as well as cosmetics and pharmaceutical industries.
              </p>
              <p className="text-secondary">
                We are committed to quality and excellence in all our products and services to give our customers better value.
              </p>
              <p className="text-secondary">
                Our Administrative office is situated at 11, Lateef Jakande Road, Agidingbi, Lagos and our Warehouse is located at 12, Ganiyu Street, Rafco Bus-stop, Ope-ilu Road, Ogun State, Nigeria.
              </p>
            </div>
          </div>
        </div>
      </div>      
    </div>
  );
};

export { About };
